import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var UcFirstPipe = (function () {
    function UcFirstPipe() {
    }
    UcFirstPipe.prototype.transform = function (text) {
        return isString(text)
            ? (text.slice(0, 1).toUpperCase() + text.slice(1))
            : text;
    };
    return UcFirstPipe;
}());
export { UcFirstPipe };
UcFirstPipe.decorators = [
    { type: Pipe, args: [{ name: 'ucfirst' },] },
];
/** @nocollapse */
UcFirstPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=ucfirst.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/ucfirst.js
// module id = 271
// module chunks = 4